module.exports = __webpack_public_path__ + "static/Techcircle-4c5a899b87d6c7c81c54d4d6d8781c70.png";